const messages = {
    errors: {
        FAILED_TO_FETCH: "Failed to fetch",
        UNAUTHORIZED_ACCESS: "Unauthorized Access",
        FAILED_TO_UPLOAD_FILES: "Failed to upload files",
        PATIENT_NOT_SELECTED: "Cannot upload file. Client is not selected.",
        FAILED_TO_CHECK_PROCESSING_STATUS: "Failed to check processing status",
        SERVER_BUSY: "Server is busy. Please try again later.",
        LOTS_OF_DATA_PREP: "Lots of data prep work going on right now. We ask you to try at a later time. Thank you for your patience.",
        SERVER_ERROR_OCCURRED: "Server error occurred",
        UNEXPECTED_SERVER_RESPONSE: "Unexpected server response",
        ERROR_OCCURRED: "An error occurred",
        MISSING_AUTH_PARAMS: 'Missing authentication parameters',
        AUTHENTICATION_FAILED: "Authentication failed",
        UNEXPECTED_ERROR: "An error has occurred, please try again later.",
        FILE_DOWNLOAD_FAIL: "Failed to download file!",
        UNABLE_TO_FETCH_CLIENTS: "Unable to fetch Client Details.",
        UNABLE_TO_FETCH_CONTAINER_FILES: "Unable to fetch document container files.",
        MAX_FILES: "We can process a maximum of 20 files at a time",
        FAILED_TO_CREATE_ZIP: "Failed to create zip file",
        CLIENT_NOT_SELECTED: "Cannot upload file. Client is not selected.",
        FAILED_TO_SAVE_DATA_TO_SECURE_FOLDER: "Failed to Save Data to Secure Folder",
        MISSING_REQUIRED_PARAMS: 'Required params are missing',
        ERROR_WHILE_AUTHENTICATION: 'An error occurred during authentication',
        SESSION_EXPIRED: "Session Expired",

        /*** Parameterized Messages */
        SERVER_RESPONSE: (status, statusText) => `Server returned ${status}: ${statusText}`,
    },
  
    notifications: {
        MAX_FILES_UPLOADED: "You can upload a maximum of 20 files.",
        FILE_DOWNLOAD_SUCCESSFULL: "File downloaded successfully!",
        LOADING_CLIENTS: 'Loading Clients...',
        NO_CLIENTS_FOUND: 'No Clients Found',
        LOADING_CONTAINER_FILES: 'Loading Files...',
        NO_CONTAINER_FILES_FOUND: 'No Files Found',
        FILE_ALREADY_SELECTED: (filename) => `${filename} is already in the selected files list.`,
        DATA_SAVED_TO_SECURE_FOLDER: "Data is saved to Secure Folder",

        /*** Parameterized Messages */
        FILE_SIZE_EXCEEDED_5MB: (filename) => `${filename} exceeds the 5MB size limit and will be skipped.`,
        FILE_ALREADY_UPLOADED: (filename) => `${filename} is already uploaded and will be skipped.`,
        FILE_NOT_SUPPORTED: (filename) => `${filename} is not a supported format and will be skipped`,
        EXTRA_FILES_WILL_BE_IGNORED: (filesCount) =>  `Only ${filesCount} file(s) can be added. Extra files will be ignored.`,

    },

    urls: {
        HOME: "/",
        UNAUTHORIZED: "/unauthorized",
        PREVIEW: "/preview",

    },
  };
    
export default messages;
